<template>
  <div class="slides-container">
    <div class="slide" v-for="(slide, index) in slides" :key="index"
      :style="{ display: slide.display, position: 'absolute', top: 0, backgroundImage: `linear-gradient(-90deg, #00000000 0%, #060606 63%), url(${slide.Img})` }">
      <div class="t">
        <div>
          <h1 class="title">Procurando<br> <span class="title">{{ slide.sublineSecondLine }}?</span></h1>
        </div>
        <div>
          <p class="descricao">Oferecemos remoções 24 horas, com atendimento em toda a região. Estamos sempre à sua
            disposição, todos os dias da semana, inclusive feriados!</p>
        </div>
        <div>
          <button  class="btn b1" @click="$emit('show-component','telefone')"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-telephone-fill" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
            </svg>&nbsp;LIGUE AGORA 24 HORAS</button>
        </div>
      </div>
    </div>
  </div><br><br><br><br>
</template>
<script>
import pesquisas from '@/assets/pesquisas.json'

export default {
  name: 'banner-cps',
  data () {
    return {
      slides: [
        {
          sublineSecondLine: '',
          Img: require('@/assets/b02.webp'),
          srcset: `${require('@/assets/b02.webp')} 400w,
                   ${require('@/assets/b02.webp')} 800w,
                   ${require('@/assets/b02.webp')} 1200w`,
          display: 'none',
          isVisible: false
        },
        {
          sublineSecondLine: '',
          Img: require('@/assets/b02.webp'),
          srcset: `${require('@/assets/b02.webp')} 400w,
                   ${require('@/assets/b02.webp')} 800w,
                   ${require('@/assets/b02.webp')} 1200w`,
          display: 'block',
          isVisible: true
        }
      ]
    }
  },
  mounted () {
    this.setRandomSubline()
    this.nextSlide()
  },
  methods: {
    getRandomSubline () {
      return pesquisas[Math.floor(Math.random() * pesquisas.length)]
    },
    setRandomSubline () {
      this.slides.forEach(slide => {
        slide.sublineSecondLine = this.getRandomSubline()
      })
    },
    nextSlide () {
      const currentSlide = this.slides.findIndex(slide => slide.display === 'block')
      const nextSlide = (currentSlide + 1) % this.slides.length
      this.slides[currentSlide].display = 'none'
      this.slides[currentSlide].isVisible = false
      this.slides[nextSlide].display = 'block'
      this.slides[nextSlide].isVisible = true
      setTimeout(this.nextSlide, 7000)
    }
  }
}
</script>
<style scoped lang="scss">
* {
  overflow: hidden;
}
.slides-container {
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.slide {
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  align-items: center;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.slide[style*="display: block;"] {
  opacity: 1;
}

.t {
  position: absolute;
  bottom: 2px;
  left: 10px;
  display: flex;
  flex-direction: column;
  z-index: 10;
  justify-content: center;
  align-items: start;
  max-width: 50vw !important;
  min-height: 100%!important;
  * {
    text-align: left!important;
  }
  p {
    color: #c7c9d3 !important;
  }

  @media only screen and (max-width: 600px) {
    margin-left: 2.5vw;
    max-width: 95vw !important;
    min-width: 95vw !important;
    max-height: 50%!important;
  }
}
@keyframes pulse {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.01,1.01,1.01)
    }

    to {
        transform: scaleX(1)
    }
}
@keyframes pisca {
    70% {
        box-shadow: 0 0 0 25px transparent
    }

    to {
        box-shadow: 0 0 0 0 transparent
    }
}
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 15px 30px!important;
  margin: 30px;
  border: none;
  border-radius: 99px;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  max-width: 20vw !important;

  @media only screen and (max-width: 600px) {
    max-width: 80vw !important;
  }

  cursor: pointer;
}

</style>
